import * as React from "react";
import type { SVGProps } from "react";
const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      d="M3.43 4a.75.75 0 1 0 0 1.5h13.126a.75.75 0 1 0 0-1.5H3.43Zm0 5.25a.75.75 0 1 0 0 1.5h13.126a.75.75 0 1 0 0-1.5H3.43Zm0 5.25a.751.751 0 1 0 0 1.5h13.126a.75.75 0 1 0 0-1.5H3.43Z"
    />
  </svg>
);
export default SvgList;
